var render, staticRenderFns
import script from "./fileDownload.vue?vue&type=script&lang=js&"
export * from "./fileDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd11a6",
  null
  
)

export default component.exports